module.exports = __webpack_public_path__ + "img/visual_platform_1.4c0910db.png";